function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "14",
  height: "19",
  viewBox: "0 0 14 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.75.531a.873.873 0 00-.526.391L8.092 2.824l4.018 2.25 1.132-1.902a.831.831 0 00-.32-1.156L10.415.613A.883.883 0 009.75.53zM8.07 6.255l.986.551-5.605 9.414-.777.202-.208-.754L8.07 6.255zM.587 15.427L7.43 3.935l4.018 2.25-6.842 11.492-3.17.823-.849-3.073z",
  fill: "#057CCC"
})));